<template>
  <div class="container" id="news">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-left">
                <a>
                  <router-link to="/home">
                    <img class="image col-xs-3" id="home" src="@/assets/news/home.png" height="50" width="50" alt="" />
                  </router-link> 
                </a> 
              </div>
              <div class="card-body">
                <div id="weatherApp">
                  <div class="temp-format btn-group" role="group" aria-label="Temperature format">
                    <button @click="getCnn" type="button" class="btn btn-outline-secondary">Get News</button>
                  </div>
                  <div class="weather-details text-info">
                    <h3 class="text-left">{{channel}} news at {{ setTime() }}</h3>
                    <p class="weather-temperature text-center">
                       <!-- Add news here...   -->
                       <div class="row" v-for="(data, index) in articles" :key= "data.title">
                         <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <p v-if="data['urlToImage']!=''"><img :src="data['urlToImage']" height="90" width="160" alt="" /></p>
                         </div>
                         <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8" align="left">
                            <p><a :href="data['url']" target="_blank">
                                  <h5><p>&nbsp{{data['title']}} </p></h5>
                               </a>
                            </p>
                            <!-- If channel is hong kong, it shows descrition instead of content -->
                            <p v-if="channel !== 'Hong Kong'">&nbsp{{data['content']}}</p>
                            <p v-else>&nbsp{{data['description']}}</p>
                          </div>
                          <!--<p>Author: {{data['author']}}</p>-->
                          
                          <!--<p><a :href="data['url']">.....<small class='text-primary'>link</small></a></p>-->
                       </div>       
                    </p>
                  </div>
                </div>
              </div>
              <div class="card-footer text-center">
                <small>Welcome to WeWaMart.</small>
              </div>
            </div>
          </div>
        </div>
  </div>

 </template> 

<script>
import cnn from '@/assets/news/cnn.png'

export default {
  name: 'news',
  props: ['channel'],
  data() {
    return {
      source:'',
      articles: []
    }
  },
  mounted() {
      var goto = '';
      //this.channel , this is passed params from Home component.
      if (this.$store.getters.channel=='CNN'){
        this.channel='CNN';
        goto = 'https://newsapi.org/v2/top-headlines?sources=cnn&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0';
        }
      else if (this.$store.getters.channel=='CNBC') {
        this.channel='CNBC';
        goto = 'https://newsapi.org/v2/top-headlines?sources=cnbc&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0';
      }
      else if (this.$store.getters.channel=='WSJ') {
        this.channel='Wall Street Journal';
        goto = 'https://newsapi.org/v2/top-headlines?sources=the-wall-street-journal&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='REUTERS') {
        this.channel='Reuters';
        goto = 'https://newsapi.org/v2/top-headlines?sources=reuters&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='BLOOMBERG') {
        this.channel='Bloomberg';
        goto = 'https://newsapi.org/v2/top-headlines?sources=bloomberg&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='FT') {
        this.channel='Financial Times';
        goto = 'https://newsapi.org/v2/top-headlines?sources=financial-times&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='ECONOMIST') {
        this.channel='The Economist';
        goto = 'https://newsapi.org/v2/top-headlines?sources=the-economist&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
       else if (this.$store.getters.channel=='AU') {
        this.channel='Australia';
        goto = 'https://newsapi.org/v2/top-headlines?country=au&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='HK') {
        this.channel='Hong Kong';
        goto = 'https://newsapi.org/v2/top-headlines?country=hk&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='BBC') {
        this.channel='BBC Worldwide';
        goto = 'https://newsapi.org/v2/top-headlines?sources=bbc-news&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='BUSINESSINSIDER') {
        this.channel='Business Insider';
        goto = 'https://newsapi.org/v2/top-headlines?sources=business-insider&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='NEWYORKTIMES') {
        this.channel='The New York Times';
        goto = 'https://newsapi.org/v2/top-headlines?sources=the-new-york-times&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='USATODAY') {
        this.channel='USA Today';
        goto = 'https://newsapi.org/v2/top-headlines?sources=usa-today&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='WASHINGTONPOST') {
        this.channel='The Washington Post';
        goto = 'https://newsapi.org/v2/top-headlines?sources=the-washington-post&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='WASHINGTONTIMES') {
        this.channel='The Washington Times';
        goto = 'https://newsapi.org/v2/top-headlines?sources=the-washington-times&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else if (this.$store.getters.channel=='CBS') {
        this.channel='CBS';
        goto = 'https://newsapi.org/v2/top-headlines?sources=cbs-news&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0'
      }
      else {
        this.channel='CNN';
        goto = 'https://newsapi.org/v2/top-headlines?sources=cnn&apiKey=fadd4a5b041a4442aca7f708ad6cf4f0';
      };

      this.$http.get(goto).then(function(response){
        return JSON.parse(response.bodyText);
      })
      .then(function(response){
        this.articles=response.articles;
      })
      .catch(function(err){
        console.log(err);
      })
      
  },
  methods: {
	  setTime: function() {
      var timeAtLoad = (new Date());/*this.time;*/
      return timeAtLoad.toLocaleTimeString([], {timeZone: 'Australia/Sydney', hour: '2-digit', minute:'2-digit', hour12: true})
		},
		getCnn: function() {
	  }
	}
}
</script>

<style scoped>
    body {
      padding: 2rem 0;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1rem;
    }

    .temp-format {
      float: right;
      margin-bottom: 2rem;
      
      button {
        width: auto;
      }
    }

    .weather-details {
      clear: both;
    }

    .weather-temperature {
      font-size: 3rem;
    }

    .icon {
      font-size: 3rem;  
      margin-bottom: 1rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/news.vue